import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API, authHeaders, errorText } from "@/lib/api";

const FIELDS = [
  ["diagnostic", "Diagnostic submitted", "Fires when someone completes the 5-question diagnostic and gets their PDF guide."],
  ["interest", "Course interest", "Fires when someone submits \u201cI\u2019m interested\u201d on a course."],
  ["curriculum", "Curriculum download", "Fires when someone submits the curriculum form and the PDF download starts."],
  ["toolkit", "Toolkit sign-up", "Fires when someone signs up for the free AI Project Toolkit."],
  ["book_call", "Book a call", "Fires when someone clicks a \u201cBook a 30-minute call\u201d button (opens Calendly)."],
  ["resume", "Resume generated", "Fires once when Resume Studio finishes generating a resume."],
  ["free_signup", "Free live class sign-up", "Fires when someone joins the free live classes at /free."],
];

export const TrackingTab = () => {
  const [v, setV] = useState(Object.fromEntries(FIELDS.map(([k]) => [k, ""])));
  const [busy, setBusy] = useState(false);
  useEffect(() => { axios.get(`${API}/site-config`).then((r) => setV((x) => ({ ...x, ...(r.data?.conversions || {}) }))).catch(() => {}); }, []);
  const save = async () => {
    setBusy(true);
    try { await axios.put(`${API}/admin/tracking`, v, { headers: authHeaders() }); toast.success("Conversion labels saved. They are live on the site now."); }
    catch (e) { toast.error(errorText(e)); }
    finally { setBusy(false); }
  };
  return (
    <div data-testid="admin-tracking" className="max-w-[760px] rounded-xl border border-slate-200 bg-white p-6">
      <h2 className="font-display text-[22px] font-bold text-[#0B1B33]">Google Ads conversions</h2>
      <p className="mt-1 text-[14px] text-slate-600">The Google tag <b>AW-18516139542</b> is on every page. Paste the <b>send_to</b> value of each conversion action (Google Ads → Goals → Conversions → your action → Tag setup → Use Google tag). Leave a field empty to switch that conversion off.</p>
      <div className="mt-6 space-y-5">
        {FIELDS.map(([k, label, help]) => (
          <label key={k} className="block">
            <span className="text-[14px] font-semibold text-[#0B1B33]">{label}</span>
            <input data-testid={`tracking-${k}`} value={v[k] || ""} onChange={(e) => setV({ ...v, [k]: e.target.value })} placeholder="AW-18516139542/AbC-D_efG123"
              className="mt-1.5 w-full rounded-lg border border-slate-300 px-3 py-2.5 font-mono text-[14px] focus:border-[#0E9384] focus:outline-none" />
            <span className="mt-1 block text-[12px] text-slate-600">{help}</span>
          </label>
        ))}
      </div>
      <button data-testid="tracking-save-btn" onClick={save} disabled={busy} className="btn-teal mt-6 rounded-lg px-6 py-2.5 text-[14px] font-semibold disabled:opacity-60">{busy ? "Saving…" : "Save labels"}</button>
    </div>
  );
};
